import React from "react";
import { Router, Switch, Route, Link } from "react-router-dom";
import { history } from "./history";
import { route } from "./constants";

function App() {
  return (
    <Router history={history}>
      <Switch>
        {route.map((value, index) => (
          <Route key={index} {...value} />
        ))}
        <Route
          render={() => {
            return (
              <>
                <h1>Page Not Found!</h1>;
                <Link to="/" className="btn btn-primary">
                  Kembali ke dashboard
                </Link>
              </>
            );
          }}
        />
      </Switch>
    </Router>
  );
}

export default App;
